<template>
  <div class="w-full">
    <div class="px-6 lg:px-8 pt-5">
      <h2 class="text-2xl font-semibold text-zinc-800">
        Cart
      </h2>
      <p class="mt-1 text-sm text-zinc-600">
        Create direct checkout products, control fulfillment behavior, and publish shareable charge links.
      </p>
    </div>

    <div class="mt-3 border-b border-zinc-200">
      <nav
        class="flex px-6 lg:px-8 space-x-8"
        aria-label="Cart Tabs"
      >
        <router-link
          v-for="tab in tabs"
          :key="tab.name"
          :to="tab.to"
          class="whitespace-nowrap py-4 px-1 border-b-2 text-sm font-medium"
          :class="tab.current
            ? 'border-[#2D8CFF] text-[#2D8CFF]'
            : 'border-transparent text-zinc-500 hover:text-zinc-700 hover:border-zinc-300'"
          @click="setActiveTab(tab.name)"
        >
          {{ tab.name }}
        </router-link>
      </nav>
    </div>

    <div class="p-6 lg:px-8">
      <router-view />
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();
const tabs = ref([
  { name: 'Products', to: '/creator/cart/products', current: false },
]);

const updateActiveTab = () => {
  const currentPath = String(route.path || '');
  tabs.value.forEach((tab) => {
    tab.current = currentPath === tab.to;
  });
};

const setActiveTab = (name) => {
  tabs.value.forEach((tab) => {
    tab.current = tab.name === name;
  });
};

watch(route, updateActiveTab, { immediate: true });
</script>
